export default __webpack_public_path__ + "static/media/fragrance-search.c1c005a9.png";